import { Head } from '@inertiajs/react';
import { MainLayout } from '../../layouts/MainLayout';
import { OngHero } from '../../components/ong-landing/OngHero';
import { SocialProof } from '../../components/ong-landing/SocialProof';
import { WhyImpact } from '../../components/ong-landing/WhyImpact';
import { ProblemSection } from '../../components/ong-landing/ProblemSection';
import { OngStandard } from '../../components/ong-landing/OngStandard';
import { Professionalize } from '../../components/ong-landing/Professionalize';
import { TargetAudience } from '../../components/ong-landing/TargetAudience';
import { OngProducts } from '../../components/ong-landing/OngProducts';
import { FinalCTA } from '../../components/ong-landing/FinalCTA';
import { SEOBlock } from '../../components/ong-landing/SEOBlock';
import type { OngLandingProps } from '../../types/ong-landing';

export default function OngLanding({ stats, featuredProducts, appUrl, loginUrl, whatsappUrl }: OngLandingProps) {
  return (
    <MainLayout>
      <Head>
        <title>Frutas y Verduras para Organizaciones Sociales | Abasto Virtual</title>
        <meta
          name="description"
          content="Proveedor de frutas y verduras frescas para comedores comunitarios, hogares y fundaciones en Córdoba. Entrega programada, facturación formal y precios mayoristas."
        />
        <link rel="canonical" href={`${appUrl}/organizaciones-sociales`} />
      </Head>

      <OngHero loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <SocialProof stats={stats} />
      <WhyImpact />
      <ProblemSection />
      <OngStandard />
      <Professionalize />
      <TargetAudience />
      <OngProducts products={featuredProducts} />
      <FinalCTA loginUrl={loginUrl} whatsappUrl={whatsappUrl} />
      <SEOBlock appUrl={appUrl} />
    </MainLayout>
  );
}
